module.exports = __webpack_public_path__ + "img/loader.5fe0e55f.gif";